/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable, OnInit, OnDestroy} from '@angular/core';
import {StageProvider} from '../providers';
import {RestResponse, Stage} from '../model';
import {BehaviorSubject, Observable} from 'rxjs';
import {SearchableProvider} from '../model/interface/searchable.provider';
import { ModeService } from './mode.service';
import { LogService } from 'src/app/services';

@Injectable()
export class StageService implements SearchableProvider {
  stages = new BehaviorSubject<Stage[]>([]);
  stages$ = this.stages.asObservable();

  constructor(
    private stageProvider: StageProvider,
    private modeService: ModeService,
    public logService : LogService
  ) {
    this.modeService.mode$.subscribe(mode => {
      if(mode) {
        stageProvider.getStages(mode)
          .subscribe(data => {
            if (data.success) {
              this.stages.next(Stage.parseArray(data.result));
            } else this.logService.error(data);
          }, error => {
            this.logService.error(error);
          });
      }
    });
  }

  getStageById(id: string): Stage {
    if (this.stages.getValue())
      return this.stages.getValue().filter(stage => stage.ID === id)[0];
    else return null;
  }

  getNextStageId(id: string): string {
    if (this.stages.getValue()) {
      const currentStageIndex = this.stages.getValue().filter(stage => stage.ID === id)[0].ORDER + 1;
      return this.stages.getValue().sort((a, b) => a.ORDER > b.ORDER ? 1 : -1)
        .filter(stage => stage.ORDER >= currentStageIndex && !stage.FLOW_SKIP)[0].ID;
    }
  }

  isLastStage(id: string): boolean {
    if (this.stages.getValue()) {
      const currentStageIndex = this.stages.getValue().filter(stage => stage.ID === id)[0].ORDER + 1;
      return this.stages.getValue().filter(stage => stage.ORDER === currentStageIndex).length === 0;
    } else return false;
  }

  getSearchType(): string {
    return 'STAGE';
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return undefined;
  }

  search(query?: string, id?: string): Observable<any> {
    return this.stages.asObservable();
  }
}
